var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('BackButton'),_c('Table',{attrs:{"table-head":_vm.header,"table-body":_vm.body,"tableData":_vm.tableData,"isHover":false,"request-function":_vm.getMemberStatistics,"more-mode":"table"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }